module.exports = __webpack_public_path__ + "img/sam.a550de66.jpg";